// Core
import { create } from "zustand";
import { devtools } from "zustand/middleware";

type ModalConfirmType = {
  active: React.JSX.Element | null;
  show: (component: React.JSX.Element) => void;
  showCloseButton: boolean;
  setShowCloseButton: (val: boolean) => void;
  close: () => void;
};

const ModalConfirmStore = create(
  devtools<ModalConfirmType>((set) => ({
    active: null,
    showCloseButton: true,
    setShowCloseButton: (val: boolean) => set({ showCloseButton: val }),
    show: (component: React.JSX.Element) => set({ active: component }),
    close: () => set({ active: null }),
  })),
);

export default ModalConfirmStore;
